import(/* webpackMode: "eager" */ "/vercel/path0/app/work/page.tsx")